export const CREATE_COMPANY_EDIT_REQUEST_REQUEST = "CREATE_COMPANY_EDIT_REQUEST_REQUEST";
export const CREATE_COMPANY_EDIT_REQUEST_SUCCESS = "CREATE_COMPANY_EDIT_REQUEST_SUCCESS";
export const CREATE_COMPANY_EDIT_REQUEST_FAILURE = "CREATE_COMPANY_EDIT_REQUEST_FAILURE";

export const GET_COMPANY_EDIT_REQUEST_REQUEST = "GET_COMPANY_EDIT_REQUEST_REQUEST";
export const GET_COMPANY_EDIT_REQUEST_SUCCESS = "GET_COMPANY_EDIT_REQUEST_SUCCESS";
export const GET_COMPANY_EDIT_REQUEST_FAILURE = "GET_COMPANY_EDIT_REQUEST_FAILURE";

export const UPDATE_COMPANY_EDIT_REQUEST_REQUEST = "UPDATE_COMPANY_EDIT_REQUEST_REQUEST";
export const UPDATE_COMPANY_EDIT_REQUEST_SUCCESS = "UPDATE_COMPANY_EDIT_REQUEST_SUCCESS";
export const UPDATE_COMPANY_EDIT_REQUEST_FAILURE = "UPDATE_COMPANY_EDIT_REQUEST_FAILURE";

export const DELETE_COMPANY_EDIT_REQUEST_REQUEST = "DELETE_COMPANY_EDIT_REQUEST_REQUEST";
export const DELETE_COMPANY_EDIT_REQUEST_SUCCESS = "DELETE_COMPANY_EDIT_REQUEST_SUCCESS";
export const DELETE_COMPANY_EDIT_REQUEST_FAILURE = "DELETE_COMPANY_EDIT_REQUEST_FAILURE";

export const CLEAR_COMPANY_EDIT_REQUEST = "CLEAR_COMPANY_EDIT_REQUEST";
